import { render, staticRenderFns } from "./resultDc.vue?vue&type=template&id=17831064"
import script from "./resultDc.vue?vue&type=script&lang=js"
export * from "./resultDc.vue?vue&type=script&lang=js"
import style0 from "./resultDc.vue?vue&type=style&index=0&id=17831064&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports